import React, { Component } from "react";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";

import TagColor from "./TagColor";

import { LANGUAGES } from "../../constants/common";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const theme = {
  container: {
    position: "relative",
    width: "100%",
  },
  input: {
    maxWidth: "100%",
    height: "36px",
    fontSize: "1em",
  },
  inputFocused: {
    outlined: "none",
  },
  suggestionsContainer: {
    display: "none",
  },
  suggestionsContainerOpen: {
    display: "block",
    position: "absolute",
    top: "36px",
    width: "100%",
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    backgroundColor: colors.white,
    borderRadius: "3px",
    zIndex: "2500",
    fontWeight: "normal",
    color: colors.black54,
    fontSize: "1em",
    maxHeight: "200px",
    overflow: "auto",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
    textAlign: "left",
  },
  suggestion: {
    cursor: "pointer",
    padding: "5px",
  },
  suggestionHighlighted: {
    backgroundColor: colors.lightGreenBg,
  },
};

const styles = {
  endAdornment: {
    padding: "5px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  selectValue: {
    padding: "8.5px 0px",
    fontSize: "0.875em",
  },
  selectFilter: {
    width: "100%",
    margin: 0,
    fontWeight: "normal",
    textAlign: "left",
    fontSize: "0.875em",
  },
};

class SmartSearchProfiles extends Component {
  mounted = false;

  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      suggestions: [],
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getSuggestions = (value) => {
    let inputValue = value.trim().toLowerCase();
    if (inputValue.length < 3) {
      return [];
    } else {
      return this.props.getSuggestions(value);
    }
  };

  onSuggestionsFetchRequested = async ({ value }) => {
    let suggestions = await this.getSuggestions(value);
    this.setState({
      suggestions,
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onSuggestionSelected = (event, suggestion) => {
    this.props.onSelect(suggestion.suggestion, this.props.filter);
  };

  handleChange = (event, { newValue }) => {
    this.setState({
      inputValue: newValue,
    });
  };

  handleClear = () => {
    this.setState({
      inputValue: "",
    });
    this.props.onSelect("", this.props.filter);
  };

  getSuggestionValue = (suggestion) => {
    let value = suggestion;
    this.props.filter.forEach((level) => {
      value = value[level];
    });
    if (value) {
      return value.toString();
    }
    return value;
  };

  renderSuggestion = (suggestion) => {
    //console.log(suggestion);
    //return <div>{this.getSuggestionValue(suggestion)}</div>;
    return (
      <Grid container direction="column">
        <Grid item>
          <Grid container>
            <Grid item className="text-54" style={{ marginRight: "20px" }}>
              {`${get(suggestion, ["firstname"])} ${get(suggestion, [
                "lastname",
              ])}`}
            </Grid>
            <TagColor color={`#${get(suggestion, ["tag", "color", "rgb"])}`} />
            <Grid item className="text-54">
              {get(suggestion, ["tag", `name_${this.props.language}`])}
            </Grid>
          </Grid>
        </Grid>
        <Grid item></Grid>
      </Grid>
    );
  };

  renderInputComponent = (inputProps) => {
    return (
      <TextField
        placeholder={I18n.get("site_search")}
        variant="outlined"
        {...inputProps}
        InputProps={{
          inputProps: {
            onFocus: this.props.onFocus,
            className: this.props.classes.selectValue,
          },
          startAdornment: (
            <InputAdornment position="start">
              <IconButton
                edge="start"
                style={{ opacity: "0.54", padding: "9px 0px 9px 6px" }}
              >
                <img
                  src={images.searchIcon}
                  alt="search"
                  width="17px"
                  height="17px"
                />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment:
            this.state.inputValue.length > 0 ? (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={this.handleClear}
                  style={{ opacity: "0.54" }}
                  classes={{ root: this.props.classes.endAdornment }}
                >
                  <img
                    src={images.closeIcon}
                    alt="search_close"
                    width="12px"
                    height="12px"
                  />
                </IconButton>
              </InputAdornment>
            ) : (
              <></>
            ),
        }}
        margin="dense"
        className={this.props.classes.selectFilter}
      />
    );
  };

  render() {
    return (
      <Autosuggest
        theme={theme}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={{
          value: this.state.inputValue,
          onChange: this.handleChange,
        }}
        renderInputComponent={this.renderInputComponent}
      />
    );
  }
}

SmartSearchProfiles.propTypes = {
  language: PropTypes.oneOf(LANGUAGES).isRequired,
  getSuggestions: PropTypes.func.isRequired,
  filter: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default withStyles(styles)(SmartSearchProfiles);
